var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipsisCircle = function SvgEllipsisCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16m1 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-5 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
export default SvgEllipsisCircle;